import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {filter, map, switchMap} from "rxjs/operators";
import * as firebase from "firebase/compat";

@Injectable({
  providedIn: 'root'
})
export class VerifiedGuard  {

  constructor(private afAuth: AngularFireAuth, private router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.afAuth.user
      .pipe<firebase.default.User, boolean>(
        filter(u => u != null),
        switchMap(u => u.getIdTokenResult().then((res) => {
          if (!res.claims.verified)
            this.router.navigate(['/wachten']);
          return res.claims.verified;
        }))
      );
  }

}
